export type AssignMechanicType = {
  id?: string | null;
  name?: string | null;
  isDefault?: boolean | null;
  costCenterId?: string | null;
};
